import gql from 'graphql-tag';

export const CATEGORY_TRANSACTION_FRAGMENT = gql`
  fragment CategoryTransactionInfo on Category {
    id
    name
    constant_code
  }
`;
